module.exports = __webpack_public_path__ + "static/media/art7.3912146a.png";